import { render, staticRenderFns } from "./FAdviser.vue?vue&type=template&id=2882cd41&scoped=true&"
import script from "./FAdviser.vue?vue&type=script&lang=js&"
export * from "./FAdviser.vue?vue&type=script&lang=js&"
import style0 from "./FAdviser.vue?vue&type=style&index=0&id=2882cd41&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2882cd41",
  null
  
)

export default component.exports